import { snapshotJpeg } from "../inference/preprocess.js";
import { makeThumbnail } from "../storage/thumbnail.js";

export function sampleTimes(duration, count) {
  if (!Number.isFinite(duration) || duration <= 0) return [0];
  const n = Math.max(1, count);
  return Array.from({ length: n }, (_, i) => Number(((duration * (i + 0.5)) / n).toFixed(3)));
}

export function pickEvenly(items, count) {
  if (items.length <= count) return [...items];
  return Array.from({ length: count }, (_, i) => items[Math.floor(((i + 0.5) * items.length) / count)]);
}

export function loadVideoFile(file) {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    video.preload = "auto";
    video.muted = true;
    video.playsInline = true;
    video.src = URL.createObjectURL(file);
    video.onloadeddata = () => resolve(video);
    video.onerror = () => reject(new Error("Video non leggibile"));
  });
}

export function seek(video, time) {
  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => reject(new Error("Seek timeout")), 5000);
    video.onseeked = () => { clearTimeout(timer); resolve(video); };
    video.currentTime = time;
  });
}

export async function analyzeVideoFile(file, classifier, { frames = 12, snapshots = 4, detector = null,
  onProgress = () => {}, onError = () => {} } = {}) {
  const video = await loadVideoFile(file);
  try {
    const times = sampleTimes(video.duration, frames);
    const snapshotTimes = new Set(pickEvenly(times, snapshots));
    const distributions = [];
    const images = [];
    let thumbnail = null;
    let dogFrames = 0;
    let checkedFrames = 0;
    for (let i = 0; i < times.length; i += 1) {
      await seek(video, times[i]);
      if (detector?.ready) {
        const detection = await detector.find(video, onError);
        if (detection) {
          checkedFrames += 1;
          if (!detection.dogs.length) {
            onProgress(Math.round(((i + 1) / times.length) * 100));
            continue;
          }
          dogFrames += 1;
        }
      }
      if (classifier?.ready) distributions.push(await classifier.probabilities(video, "fit"));
      if (snapshotTimes.has(times[i])) images.push(snapshotJpeg(video, 640, 0.85));
      if (!thumbnail) thumbnail = makeThumbnail(video);
      onProgress(Math.round(((i + 1) / times.length) * 100));
    }
    return { distributions, snapshots: images, thumbnail, dogFrames, checkedFrames };
  } finally {
    URL.revokeObjectURL(video.src);
  }
}
